export default __webpack_public_path__ + "static/media/ic_trading.552590c4.svg";